// @flow

import * as React from 'react'
import styled from 'styled-components'
import { Colors } from './../Colors'
import { BaseButton, IconInTheButton, type BaseButtonProps } from './BaseButton'

const StyledPrimaryButton = styled(BaseButton)`
  color: ${Colors.brand};
  border-color: ${Colors.brand};
  background-color: transparent;

  &:hover {
    color: ${process.env.REACT_APP_LIGHT_UI === 'true'
      ? Colors.white85
      : Colors.black85};
    border-color: ${Colors.brand};
    background-color: ${Colors.brand};
  }

  &:disabled {
    color: ${process.env.REACT_APP_LIGHT_UI === 'true'
      ? Colors.black30
      : Colors.white30};
    border-color: ${process.env.REACT_APP_LIGHT_UI === 'true'
      ? Colors.black30
      : Colors.white30};
    background-color: transparent;
  }

  & ${IconInTheButton} path {
    fill: ${Colors.brand};
    transition: fill 0.25s ease-in-out;
  }

  &:hover ${IconInTheButton} path {
    fill: ${process.env.REACT_APP_LIGHT_UI === 'true'
      ? Colors.white85
      : Colors.black85};
  }

  .highlight & {
    color: ${Colors.white100};
    border-color: ${Colors.white100};
  }
`

export const PrimaryButton = ({
  children,
  ...otherProps
}: {
  ...BaseButtonProps,
}): React.Node => (
  <StyledPrimaryButton {...otherProps}>{children}</StyledPrimaryButton>
)
